"use strict";

var _toConsumableArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/createClass.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dayjs_1 = __importDefault(require("dayjs"));

var firestore_1 = require("firebase/firestore");

var firebase_1 = require("../../config/firebase");

var functions_1 = require("../functions");

var Content = /*#__PURE__*/function () {
  function Content() {
    _classCallCheck(this, Content);

    this.collectionName = 'contents';
  }

  _createClass(Content, [{
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(parentCollectionName, parentId, id) {
        var date, parentRef, docRef;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                date = (0, dayjs_1.default)().toISOString();
                parentRef = (0, firestore_1.doc)(firebase_1.firestore, parentCollectionName, parentId);
                docRef = (0, firestore_1.doc)(parentRef, this.collectionName, id);
                _context.next = 5;
                return (0, firestore_1.updateDoc)(docRef, {
                  deleted: true,
                  deletedAt: date,
                  updatedAt: date
                });

              case 5:
                return _context.abrupt("return", (0, firestore_1.updateDoc)(parentRef, {
                  updatedAt: date
                }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _delete(_x, _x2, _x3) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "insertIntoDocument",
    value: function () {
      var _insertIntoDocument = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(collectionName, id, data) {
        var docRef, contentRef;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                docRef = (0, firestore_1.doc)(firebase_1.firestore, collectionName, id);
                contentRef = (0, firestore_1.doc)((0, firestore_1.collection)(docRef, this.collectionName));
                _context2.next = 4;
                return (0, firestore_1.setDoc)(contentRef, _objectSpread(_objectSpread({}, data), {}, {
                  createdAt: (0, dayjs_1.default)().toISOString(),
                  deleted: false,
                  updatedAt: (0, dayjs_1.default)().toISOString()
                }));

              case 4:
                _context2.next = 6;
                return (0, firestore_1.updateDoc)(docRef, {
                  updatedAt: (0, dayjs_1.default)().toISOString()
                });

              case 6:
                return _context2.abrupt("return", contentRef.id);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function insertIntoDocument(_x4, _x5, _x6) {
        return _insertIntoDocument.apply(this, arguments);
      }

      return insertIntoDocument;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(parentCollectionName, parentId, id, data) {
        var docRef;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                docRef = (0, firestore_1.doc)(firebase_1.firestore, parentCollectionName, parentId);
                _context3.next = 3;
                return (0, firestore_1.updateDoc)((0, firestore_1.doc)(docRef, this.collectionName, id), _objectSpread(_objectSpread({}, data), {}, {
                  updatedAt: (0, dayjs_1.default)().toISOString()
                }));

              case 3:
                return _context3.abrupt("return", (0, firestore_1.updateDoc)(docRef, {
                  updatedAt: (0, dayjs_1.default)().toISOString()
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x7, _x8, _x9, _x10) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "watch",
    value: function watch(collectionName, id, _next, options) {
      var _a;

      var constraints = [(0, firestore_1.where)('deleted', '==', false)];
      constraints = (0, functions_1.updateConstraints)(constraints, {
        orderDirection: (options === null || options === void 0 ? void 0 : options.orderDirection) || 'asc',
        orderField: (options === null || options === void 0 ? void 0 : options.orderField) || 'order',
        wheres: options === null || options === void 0 ? void 0 : options.wheres
      });
      constraints.push((0, firestore_1.limit)((_a = options === null || options === void 0 ? void 0 : options.limit) !== null && _a !== void 0 ? _a : parseInt(String(process.env.GATSBY_INNEDIT_WATCH_LIMIT), 10) || 250));
      return (0, firestore_1.onSnapshot)((0, firestore_1.query).apply(void 0, [(0, firestore_1.collection)(firebase_1.firestore, collectionName, id, this.collectionName)].concat(_toConsumableArray(constraints))), {
        next: function next(querySnaphot) {
          _next(querySnaphot.docs.map(function (d) {
            return _objectSpread({
              id: d.id
            }, d.data());
          }));
        }
      });
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data, options) {
        var newData, docRef;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                newData = _objectSpread(_objectSpread({}, data), {}, {
                  createdAt: (0, dayjs_1.default)().toISOString(),
                  deleted: false,
                  updatedAt: (0, dayjs_1.default)().toISOString()
                });

                if (options === null || options === void 0 ? void 0 : options.boutique) {
                  newData.boutique = options.boutique.id;
                }

                docRef = (0, firestore_1.doc)((0, firestore_1.collection)(firebase_1.firestore, 'contents'));
                _context4.next = 5;
                return (0, firestore_1.setDoc)(docRef, newData);

              case 5:
                return _context4.abrupt("return", docRef);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function create(_x11, _x12) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return Content;
}();

exports.default = Content;